﻿import { FeMapPlugin } from '@fe/maplibre-extensions';
import { type Map as MMap } from 'maplibre-gl';
import { GeoGrid } from './geo-grid';

const COLORS = {
    light: {
        grid: '#5f5f5f',
        label: '#5f5f5f',
        labelOutline: '#ffffff'
    },
    dark: {
        grid: '#5f5f5f',
        label: '#5f5f5f',
        labelOutline: '#ffffff'
    }
};

export class GridLayer implements FeMapPlugin {
    private isRendered: boolean = false;
    private grid: GeoGrid | null = null;
    private map: MMap | null = null;
    private light: boolean = true;
    private styleElement: HTMLStyleElement | null = null;

    onAdd(map: MMap) {
        this.isRendered = false;
        this.grid = null;
        this.map = map;
        this.styleElement = this.createStyleElement();
    }

    onRemove() {
        this.hide();
        this.map = null;
    }

    private createStyleElement() {
        const style = document.createElement('style');
        document.head.appendChild(style);
        return style;
    }

    show() {
        if (this.isRendered || !this.map) {
            return;
        }
        if (!this.grid) {
            this.init();
        }
        this.grid!.add();
        this.isRendered = true;
        this.updateStyles(this.light);
    }

    hide() {
        if (!this.isRendered) {
            return;
        }
        this.grid!.remove();
        this.isRendered = false;
    }

    changeStyle(light: boolean) {
        this.light = light;
        if (!this.isRendered) {
            return;
        }
        this.updateStyles(light);
    }

    private updateStyles(light: boolean) {
        const colors = light ? COLORS.light : COLORS.dark;
        // Update grid lines
        this.map!.setPaintProperty('fe-grid_parallers', 'line-color', colors.grid);
        this.map!.setPaintProperty('fe-grid_meridians', 'line-color', colors.grid);

        // Update labels via CSS
        if (!this.styleElement) {
            return;
        }

        this.styleElement.textContent = `
            .geogrid__label {
                color: ${colors.label} !important;
                text-shadow: 0 0 1px ${colors.labelOutline};
            }
        `;
    }

    private init() {
        this.grid = new GeoGrid({
            map: this.map!,
            gridStyle: {
                width: 1,
                color: this.light ? '#000000' : '#ffffff',
                dasharray: [2, 2]
            }
        });
        this.map!.off('load', this.grid.add);
    }
}
